import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/recordList/resourceTimeOverview/styles.scss';export default {
  "resourceTimeOverview": "_resourceTimeOverview_be0mz_1",
  "cell": "_cell_be0mz_8",
  "text": "_text_be0mz_21",
  "resource": "_resource_be0mz_1",
  "list": "_list_be0mz_30",
  "task": "_task_be0mz_42",
  "numberInput": "_numberInput_be0mz_46",
  "percentSign": "_percentSign_be0mz_55",
  "progression": "_progression_be0mz_59"
};